import React from "react";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import { useEventContext } from "../../../state/events/context";
import Configuration from "../../common/components/Configuration";
import { getSportConfiguration } from "../../common/config/sport-configurations";

const EventSettingsPreview = () => {
	const { state: eventState } = useEventContext();
	const { gameConfiguration, customFormData } =
		eventState.currentEventSettings();
	const { sportId } = eventState.currentEvent() || {};

	return (
		<Grid item container>
			<Accordion>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h5">Event Settings</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Configuration
						configuration={gameConfiguration}
						customFormData={customFormData}
						extension={getSportConfiguration(sportId)}
						preview
					/>
				</AccordionDetails>
			</Accordion>
		</Grid>
	);
};

export default EventSettingsPreview;
